import React, { useEffect, useState } from 'react';
import CopyToClipboard from 'react-copy-to-clipboard';
import { toast } from 'react-toastify';
import { Button } from 'react-bootstrap';
import * as react from '@coreui/react';
import Tools from '../../tools';
import { ShortTextConfig } from '../../models/short-text-config';
import './short-text-control.scss';

export default function ShortTextControl(config: ShortTextConfig): JSX.Element {
  const configParam = config;

  const [text, setText] = useState(configParam.text);
  const [numberOfChars, setNumberOfChars] = useState(configParam.numberOfChars);
  const [description, setDescription] = useState(configParam.description);

  useEffect(() => {
    setText(configParam.text);
  }, [configParam.text]);

  useEffect(() => {
    setNumberOfChars(configParam.numberOfChars);
  }, [configParam.numberOfChars]);

  useEffect(() => {
    setDescription(configParam.description);
  }, [configParam.description]);

  return (
    <div className={`d-flex align-items-center ${configParam.justifyBetween && 'justify-content-between'}`}>
      <react.CTooltip content={description || text}>
        <span>{configParam.fullDisplay ? text : Tools.shortenText(text, numberOfChars)}</span>
      </react.CTooltip>
      <Button className="d-inline copy-button ms-2">
        {/* This is a hack for mobile version. On mobile navigator.clipboard doesn't work that's why we are using CopyToClipboard */}
        <CopyToClipboard
          text={text}
          onCopy={() => {
            toast('Copied to clipboard');
          }}
        >
          <i className="icon-copy4" />
        </CopyToClipboard>
      </Button>
    </div>
  );
}
